export const notFoundRouter = [
  {
    path: "*",
    lazy: async () => {
      const { NotFound } = await import("./NotFound")
      return { Component: NotFound }
    },
  },
]
